import React, { Fragment } from "react";
import { Breadcrumbs } from "../../../AbstractElements";
import { Container } from "reactstrap";
import ProductsCollectionsTable from "./ProductCollectionsTable";
import AddProducts from "./addProducts";
import AddCollection from "./addCollection";
import { Button } from "reactstrap";
import { getAllPrograms } from "../../../store/slices/programsSlice";

import { getProductConfig } from "../../../store/slices/productConfigSlice";
import { useDispatch } from "react-redux";

const ProductsCollections = () => {
  const dispatch = useDispatch();

  const [collections, setCollections] = React.useState([]);
  const [selectedCollection, setSelectedCollection] = React.useState(null);
  const [historyRoutes, setHistoryRoutes] = React.useState({
    name: "Products",
    path: "/products",
  });

  const handleCollectionClick = (collection) => {
    setSelectedCollection(collection);
    setHistoryRoutes({
      name: collection,
    });
  };

  React.useEffect(() => {
    const fetchCollections = async () => {
      try {
        await dispatch(getAllPrograms());
        const response = await dispatch(getProductConfig());
        if (response.payload) {
          setCollections(response.payload);
        }
      } catch (error) {
        console.error("Error fetching collections:", error);
      }
    }
    fetchCollections();
  }, [dispatch]);

  // Callback for AddProducts success
  const handleProductAddSuccess = (collectionName) => {
    setSelectedCollection(collectionName);
    setHistoryRoutes({ name: collectionName });
  };

  return (
    <Fragment>
      <Breadcrumbs
        mainTitle="Products"
        parent="Products"
        title={historyRoutes.name}
        parentPath="prodcuts-collections"
      />
      {/* Add your content here */}
      {!selectedCollection && (
        <Container fluid={true}>
         
          <div className="mb-3 d-flex justify-content-end"><Button color="primary" onClick={() => setSelectedCollection("Add Collection")}>
            Add
          </Button></div>
          <div className="mb-3">
            {collections.map((collection) => (
              <div
                key={collection.id}
                className="collection-card mb-3 p-3 border rounded"
                onClick={() => handleCollectionClick(collection.name)}
                style={
                  collection.image
                    ? {
                      backgroundImage: `url(${collection.image})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      color: "#fff",
                    }
                    : {}
                }
              >
                <h5>{collection.name}</h5>
                <p>Details about {collection.name} will go here.</p>
              </div>
            ))}
          </div>

        </Container>
      )}
      {selectedCollection && (
        <>
          {selectedCollection === 'Add Collection' && (
            <AddCollection collections={collections} />
          )}

          {selectedCollection !== 'Add Collection' && selectedCollection !== 'Add Product' && (
            <Container fluid={true}>
              <ProductsCollectionsTable name={selectedCollection} history={historyRoutes} />
            </Container>
          )}
        </>
      )}
    </Fragment>
  );
};

export default ProductsCollections;
